<template>
    <xx-select
        v-if="!showText"
        v-model="innerValue"
        :list="list"
        :multiple="multiple"
        value-key="poiId"
        label-key="poiName"
        use-scroll
        v-bind="$attrs"
        placeholder="请选择或输入搜索"
        @change="onChange"
    />
    <span v-else>{{ listText }}</span>
</template>

<script>
export default {
    // 通过经营城市获取RDC
    name: 'RdcSelectByManageCity',
    props: {
        value: {
            type: [Array, Number, String],
            default: () => [],
            required: '',
        },
        cityIds: {
            type: Array,
            default: () => [],
            required: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        showText: {
            type: Boolean,
            default: false,
        },
        // 数据权限
        usePermission: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            list: [],
            innerValue: this.value,
        };
    },
    computed: {
        // innerValue: {
        //     get() { return Array.isArray(this.value) ? this.value : [this.value]; },
        //     set(val) { this.$emit('input', val); },
        // },
        listText() {
            const listMap = this.list.reduce((result, item) => {
                result[item.poiId] = item.poiName;
                return result;
            }, {});
            if (this.multiple) {
                return this.innerValue.map((val) => listMap[val]).join(', ');
            } else {
                return listMap[+this.innerValue];
            }
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal;
        },
        cityIds(newVal, oldVal) {
            if (!window._.isEqual(newVal, oldVal)) {
                this.getList();
            }
        },
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            try {
                const list = await this.$hPost('/api/vss/shepherd/product/queryRdcByManageCity', {
                    managementCityIdList: this.cityIds,
                    includeTestPoi: true,
                    usePermission: this.usePermission,
                });
                const rdcList = list.filter((item) => item.poiName.indexOf('测试') === -1 && item.poiName.indexOf('停用') === -1 && item.poiName.indexOf('废弃') === -1);
                const testRdcList = list.filter((item) => item.poiName.indexOf('测试') !== -1);
                const deactivateRdcList = list.filter((item) => item.poiName.indexOf('停用') !== -1);
                const discardRdcList = list.filter((item) => item.poiName.indexOf('废弃') !== -1);
                this.list = [...rdcList, ...testRdcList, ...deactivateRdcList, ...discardRdcList];
            } catch (error) {
                this.$message.error(error.msg || error.message || '获取仓列表失败');
            }
        },
        onChange(val, item) {
            this.$emit('input', val);
            this.$emit('change', val, item || { poiId: '', poiName: '' });
        },
    },
};
</script>

<style>

</style>
